import { Button, Checkbox, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { SummaryTable } from 'src/ui'
import { FiatCurrency } from 'src/common/static'
import * as S from '../styles'

interface PaymentInstructionsProps {
  amount: string | number
  fiatCurrency: FiatCurrency
  onProceed: () => void
}

const PaymentInstructions: React.FC<PaymentInstructionsProps> = ({
  amount,
  fiatCurrency,
  onProceed
}: PaymentInstructionsProps) => {
  const [checked, setChecked] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  // const copyToClipboard = (value: string) => {
  //   navigator.clipboard.writeText(value)
  //   alertNotification('Successfully copied to clipboard!', 'success')
  // }

  // TODO: Replace with actual reference number and transfer id
  // const referenceNumber = 'AOWEIFJPAOWEHF'
  // const transferId = 'NN5XOZBOG2WEI58D'
  const paymentMethod = 'E-Transfer'

  return (
    <Stack spacing={3} sx={{ maxWidth: '100%', width: '100%' }}>
      <S.Row>
        <Typography variant="h5" fontWeight={600}>
          Payment Instructions
        </Typography>
        <Typography variant="subtitle1" color="grey.700">
          Please complete the funds transfer to QCAD Digital Trust, account details as follows:
        </Typography>
      </S.Row>
      <S.Row>
        <Stack direction="row" spacing={4} sx={{ width: '100%' }}>
          <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Beneficiary Information
            </Typography>
            <SummaryTable
              data={[
                // {
                //   key: 'Reference Number:',
                //   value: (
                //     <Stack direction="row" alignItems="center" spacing={1}>
                //       <Typography variant="body2">{referenceNumber}</Typography>
                //       <IconButton
                //         size="small"
                //         onClick={() => copyToClipboard(referenceNumber)}
                //         aria-label="copy reference number"
                //       >
                //         <ContentCopyIcon fontSize="small" />
                //       </IconButton>
                //     </Stack>
                //   )
                // },
                {
                  key: 'Payment Method:',
                  value: (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">{paymentMethod}</Typography>
                    </Stack>
                  )
                },
                {
                  key: 'Amount (CAD):',
                  value: (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        ${amount} {fiatCurrency}
                      </Typography>
                    </Stack>
                  )
                }
                // {
                //   key: 'Transfer ID:',
                //   value: (
                //     <Stack direction="row" alignItems="center" spacing={1}>
                //       <Typography variant="body2">{transferId}</Typography>
                //       <IconButton
                //         size="small"
                //         onClick={() => copyToClipboard(transferId)}
                //         aria-label="copy transfer id"
                //       >
                //         <ContentCopyIcon fontSize="small" />
                //       </IconButton>
                //     </Stack>
                //   )
                // }
              ]}
            />
          </Stack>

          <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Beneficiary Bank Information
            </Typography>
            <SummaryTable
              data={[
                {
                  key: 'Bank Name:',
                  value: <Typography variant="body2">QCAD Digital Trust</Typography>
                },
                {
                  key: 'Bank Address:',
                  value: <Typography variant="body2">1055 West Georgia Street, Vancouver BC V6E 3P3, Canada</Typography>
                },
                {
                  key: 'Transit Number:',
                  value: <Typography variant="body2">123445</Typography>
                },
                {
                  key: 'Transit Number:',
                  value: <Typography variant="body2">000</Typography>
                },
                {
                  key: 'Canadian Clearing Code:',
                  value: <Typography variant="body2">123123123</Typography>
                },
                {
                  key: 'SWIFT Code:',
                  value: <Typography variant="body2">ROYCCAT2</Typography>
                }
              ]}
            />
          </Stack>
        </Stack>
      </S.Row>

      <S.Row>
        <Stack direction="row" spacing={1} alignItems="center">
          <Checkbox checked={checked} onChange={handleChange} />
          <Typography variant="body2">I have completed the above transaction.</Typography>
        </Stack>
      </S.Row>

      <S.Row>
        <Button variant="contained" fullWidth size="large" onClick={onProceed} disabled={!checked}>
          Proceed
        </Button>
      </S.Row>
    </Stack>
  )
}

export default PaymentInstructions
